module.exports = __webpack_public_path__ + "static/media/ticket-icon-over.6cd52f25.svg";